import { createSlice, current } from "@reduxjs/toolkit";
import * as Act from "./actions";

const initialState = {
  loading: false,
  CONTACTUS: [],
  totalCount: 0,
};

const slice = createSlice({
  name: "CONTACTUS",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(Act.getContactList.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.getContactList.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
      CONTACTUS: payload,
      totalCount: payload.total_record_count,
    }));
    builder.addCase(Act.getContactList.rejected, (state, action) => ({
      ...state,
      loading: false,
      CONTACTUS: [],
      totalCount: 0,
    }));
  },
});
export default slice;
